import React from 'react'
import CryptoAsset from "./cryptoAssetmgr.jpg"

export default function Cryptoassetmgr() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={CryptoAsset}></img>
  )
}
